import { render, staticRenderFns } from "./SettingsShipper.vue?vue&type=template&id=325c7ade&scoped=true"
import script from "./SettingsShipper.vue?vue&type=script&lang=js"
export * from "./SettingsShipper.vue?vue&type=script&lang=js"
import style0 from "./SettingsShipper.vue?vue&type=style&index=0&id=325c7ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c7ade",
  null
  
)

export default component.exports